import { EffectComposer, Bloom, DepthOfField, ChromaticAberration, Vignette } from '@react-three/postprocessing'
import { BlendFunction, KernelSize } from 'postprocessing'
import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'

// Detect mobile for performance optimization
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768

// Simple lens flare mesh component
function LensFlareSource() {
    const meshRef = useRef()

    useFrame((state) => {
        if (meshRef.current) {
            const pulse = 1 + Math.sin(state.clock.elapsedTime * 0.5) * 0.1
            meshRef.current.scale.setScalar(pulse)
        }
    })

    return (
        <mesh ref={meshRef} position={[8, 4, -10]}>
            <sphereGeometry args={[0.5, isMobile ? 8 : 16, isMobile ? 8 : 16]} />
            <meshBasicMaterial color="#fbbf24" transparent opacity={0.9} />
        </mesh>
    )
}

export default function Effects() {
    return (
        <>
            <LensFlareSource />
            <pointLight position={[8, 4, -10]} color="#fbbf24" intensity={2} distance={30} />
            <pointLight position={[-6, 3, -8]} color="#00f3ff" intensity={1} distance={20} />

            <EffectComposer multisampling={isMobile ? 0 : 8}>
                {/* Depth of Field - disabled on mobile for performance */}
                {!isMobile && (
                    <DepthOfField
                        focusDistance={0.0}
                        focalLength={0.9}
                        bokehScale={1}
                        height={480}
                    />
                )}
                <Bloom
                    intensity={isMobile ? 0.15 : 0.6}
                    luminanceThreshold={isMobile ? 0.7 : 0.4}
                    luminanceSmoothing={0.9}
                    radius={isMobile ? 0.2 : 0.4}
                    kernelSize={isMobile ? KernelSize.SMALL : KernelSize.MEDIUM}
                />
                {!isMobile && (
                    <ChromaticAberration
                        blendFunction={BlendFunction.NORMAL}
                        offset={[0.001, 0.001]}
                    />
                )}
                <Vignette
                    offset={0.3}
                    darkness={isMobile ? 0.4 : 0.6}
                    blendFunction={BlendFunction.NORMAL}
                />
            </EffectComposer>
        </>
    )
}
